import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { data } from 'jquery';
import { Csp5030Service } from '../../CSPService/CSP5030/csp5030.service';
import { Csp5030Class } from '../../CSPClass/CSP5030/csp5030-class';
@Component({
  selector: 'kt-csp5030-view',
  templateUrl: './csp5030-view.component.html',
  styleUrls: ['./csp5030-view.component.scss']
})
export class Csp5030ViewComponent implements OnInit {

  lblPageTitle: string = "";
  ReceiptList: any[] = [];
  showCollectionId = false;
  showStudentInfo = false;
  
  constructor(private router: Router,public dialogRef: MatDialogRef<Csp5030ViewComponent>, private objCsp5030Service:Csp5030Service,private changeDetectorRef: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.onGetDatas();
  }
    onGetDatas() {
      if (localStorage.getItem('currentUser') != null) {
              var userLoginDetails = JSON.parse(localStorage.getItem('currentUser'));
              var classobj = new Csp5030Class();
              classobj.UserNam= userLoginDetails.UserNam;
              this.objCsp5030Service.Receipts(classobj).subscribe((data) => {         
               this.ReceiptList = data || []; 
            });
            this.changeDetectorRef.detectChanges();
          }
        }

   onPrint(collectionId: number) {
     if (localStorage.getItem('currentUser') != null) {
            var userLoginDetails = JSON.parse(localStorage.getItem('currentUser'));
            var classobj = new Csp5030Class();
            classobj.UserNam= userLoginDetails.UserNam;
            classobj.collection_id = collectionId;
            classobj.CompanyName="VISAT";
              this.objCsp5030Service.csp5030(classobj).subscribe((data) => { 
               
                 const fileURL = URL.createObjectURL(data);
                 window.open(fileURL, '_blank');
                  this.changeDetectorRef.detectChanges(); 
            });
            this.changeDetectorRef.detectChanges();
          }
        }


indianFormatter = new Intl.NumberFormat('en-IN', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});

formatIN(value: number): string {
  const num = Number(value) || 0;
  return this.indianFormatter.format(num);
}

ReceiptTotalAmountPaid(): number {
  return this.ReceiptList.reduce((sum, item) => {
    const value = Number(String(item.total_amount_paid).replace(/,/g, '')) || 0;
    return sum + value;
  }, 0);
}

  onClose() {
  if (this.dialogRef) {
    this.dialogRef.close();
  }
}
   getComponentTitle() {
    let result =  "Receipts";
    return result;
   }


}
